import { LOADING_STATUSES } from '@yandex-int/k-common/client/api/constants';
import produce from 'immer';

import * as constants from './constants';
import { TeacherCoursesByClassState, CoursesAction } from './typings';
import { getCoursesByClass } from './utils';

const initialState: TeacherCoursesByClassState = {
    classes: {},
    requestLoadingStatus: LOADING_STATUSES.UNSENT,
};

const teacherCoursesByClassReducer = (state: TeacherCoursesByClassState = initialState, action: CoursesAction) => {
    return produce(state, (draft) => {
        // eslint-disable-line complexity
        switch (action.type) {
            case constants.GET_TEACHER_COURSES_BY_CLASS_REQUEST: {
                const { classIds } = action;

                draft.requestLoadingStatus = LOADING_STATUSES.LOADING;

                classIds.forEach((id) => {
                    if (state.classes[id]) {
                        draft.classes[id].loadingStatus = LOADING_STATUSES.LOADING;
                    } else {
                        draft.classes[id] = { list: [], loadingStatus: LOADING_STATUSES.LOADING };
                    }
                });
                break;
            }

            case constants.GET_TEACHER_COURSES_BY_CLASS_SUCCESS: {
                const { classIds, courses } = action;

                draft.requestLoadingStatus = LOADING_STATUSES.SUCCESS;

                const coursesByClass = getCoursesByClass(courses);

                classIds.forEach((id) => {
                    const coursesList = coursesByClass[id] || [];

                    draft.classes[id] = { list: coursesList, loadingStatus: LOADING_STATUSES.SUCCESS };
                });

                break;
            }

            case constants.GET_TEACHER_COURSES_BY_CLASS_ERROR: {
                const { classIds } = action;

                draft.requestLoadingStatus = LOADING_STATUSES.ERROR;

                classIds.forEach((id) => {
                    draft.classes[id].loadingStatus = LOADING_STATUSES.ERROR;
                });

                break;
            }

            case constants.CLEAR_TEACHER_COURSES_BY_CLASS: {
                const { classId } = action;

                draft.classes[classId] = { list: [], loadingStatus: LOADING_STATUSES.UNSENT };

                break;
            }

            default:
                break;
        }
    });
};

export default teacherCoursesByClassReducer;
